import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Response } from "@angular/http";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import { User, Login } from "../_models/user.model";
// import { AppConfig } from "../app.config";
import { environment } from '../../environments/environment';


@Injectable()
export class UserService {
  private rootUrl = "http://192.168.1.217:8000";
  public address1: string = "";
  public address2: string = "";
  public city: string = "";
  public state: string = "";
  public zip: string = "";

  constructor(private httpClient: HttpClient) {
    this.rootUrl = environment.API_URL
      ? environment.API_URL
      : this.rootUrl;
    // this.rootUrl = AppConfig.settings.API_URL
    //   ? AppConfig.settings.API_URL
    //   : this.rootUrl;
  }

  // User registration
  registerUser(user: User) {
    const body: User = {
      UserName: user.UserName,
      Password: user.Password,
      Email: user.Email,
      FirstName: user.FirstName,
      LastName: user.LastName
    };
    var reqHeader = new HttpHeaders({ "No-Auth": "True" });
    return this.httpClient.post(this.rootUrl + "/api/User/Register", body, {
      headers: reqHeader
    });
  }

  // User Authentication
  userAuthentication(userName, password) {
    let data = {
      username: userName,
      password: password
    };

    return this.httpClient.post(this.rootUrl + "/login", data, {});
  }

  // Site Authentication
  siteAuthentication() {
    let data = {
      api_consumer_key: environment.apiServer.apiConsumerKey,
      api_consumer_secret: environment.apiServer.apiConsumerSecret
    };

    var reqHeader = new HttpHeaders({ "No-Auth": "True" });
    return this.httpClient.post(this.rootUrl + "/authenticate", data, {
      headers: reqHeader
    });
  }

  getUserClaims() {
    return this.httpClient.get<any>(this.rootUrl + "/users");
  }

  // User Update Profile
  userUpdateProfile(postData, selectedFile) {
    // let data = {
    //   id: localStorage.getItem("userID"),
    //   company_name: postData.company_name,
    //   first_name: postData.first_name,
    //   middle_name: postData.middle_name,
    //   last_name: postData.last_name,
    //   email: postData.email,
    //   phone: postData.phone,
    //   site_url: postData.site_url
    // };
    const formData = new FormData();
    formData.append('id', localStorage.getItem("userID"));
    formData.append('company_name', postData.company_name);
    formData.append('first_name', postData.first_name);
    formData.append('last_name', postData.last_name);
    formData.append('email', postData.email);
    formData.append('phone', postData.phone);
    formData.append('site_url', postData.site_url);
    if (selectedFile != null) {
      formData.append('profile_img', selectedFile, selectedFile.name);
    }

    if (postData.type == 'Printer') {
      formData.append('address1', postData.address1);
      formData.append('address2', postData.address2);
      formData.append('city', postData.city);
      formData.append('state', postData.state);
      formData.append('zip', postData.zip);
    }
    return this.httpClient.post(this.rootUrl + "/user/profile", formData, {});
  }

  setSetting(options) {
    let data = {
      id: localStorage.getItem("userID"),
      options: options
    };
    return this.httpClient.post(this.rootUrl + "/options/set", data, {});
  }

  getSetting(options) {
    let data = {
      id: localStorage.getItem("userID"),
      options: options
    };
    return this.httpClient.post(this.rootUrl + "/options/get", data, {});
  }

  getCategoryList() {
    let data = {
      id: localStorage.getItem("userID"),
      limit:500
    };
    return this.httpClient.post(this.rootUrl + "/categories",data ,{});
  }

  getStyleList() {
    let data = {
      id: localStorage.getItem("userID"),
      limit:500
    };
    return this.httpClient.post(this.rootUrl + "/styles",data, {});
  }

  getBrandList() {
    let data = {
      id: localStorage.getItem("userID"),
      limit:500
    };
    return this.httpClient.post(this.rootUrl + "/brands",data, {});
  }

  getFitList() {
    let data = {
      id: localStorage.getItem("userID"),
      limit:500
    };
    return this.httpClient.post(this.rootUrl + "/fits",data, {});
  }

  getColorList() {
    let data = {
      id: localStorage.getItem("userID"),
      limit:500
    };
    return this.httpClient.post(this.rootUrl + "/color/families",data, {});
  }
 
}



// WEBPACK FOOTER //
// /var/www/staging.theprintlife.com/src/app/_services/user.service.ts